<template>
  <form class="flex flex-col gap-y-4" @submit.prevent="forgotPassword">
    <h2>{{ $t("forgotPassword.title") }}</h2>
    <span>{{ $t("forgotPassword.description") }}</span>
    <InputField
      v-model="inputEmail"
      required
      type="email"
      placeholder="peter.muster@gmail.com"
      :error="error"
      class="my-12"
    />
    <div class="flex gap-x-4 mt-3">
      <custom-button type="submit" variant="primary" class="flex-1" :busy="loading">
        {{ $t("forgotPassword.buttonText") }}
      </custom-button>
      <router-link :to="{ name: 'login' }">
        <custom-button variant="outlined" class="flex-1">
          {{ capitalize($t("back")) }}
        </custom-button>
      </router-link>
    </div>
  </form>
</template>

<script lang="ts" setup>
import { ref, capitalize } from "vue";
import { useFetchAction } from "@hooks/fetch";
import { useRouter } from "vue-router";
import InputField from "@components/utils/inputs/Input.vue";
import { useNotify } from "@/components/utils/notifications";
import { useI18n } from "vue-i18n";
import { useValidation } from "@/hooks/form";
import { string } from "yup";

const router = useRouter();
const notify = useNotify();
const { t } = useI18n();

const [exec, { loading }] = useFetchAction();

const inputEmail = ref("");

const {
  data: email,
  errors: error,
  validatedFn,
} = useValidation(string().email().required(), inputEmail);

const forgotPassword = validatedFn(async () => {
  try {
    await exec("/users/ask-reset-password", {
      method: "POST",
      body: {
        email: email.value,
      },
    });

    notify?.({
      variant: "success",
      title: t("forgotPassword.saveSuccess"),
    });

    await router.push({ name: "login" });
  } catch (e) {
    notify?.({
      variant: "error",
      title: t("forgotPassword.saveError"),
    });
  }
});
</script>

<style lang="scss" scoped></style>
